import { ColumnRank, ColumnName, ColumnNoc, ColumnResult, ColumnExpander, ColumnBib } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
export function TableColumns() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            {
                //Header: <Label data={"HeaderTeam"} />,
                accessor: 'sortOrder',
                className: "text-start",
                headerClassName: "w-5 text-start",
                //disableSortBy: disableSort, //habilita poder ordenar
                id: 'HasSecondValue',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let second = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? '(2VT)' : ''
                    return (<span>{second}</span>)
                }
            },
            ColumnResult({ label: "Score" }),
            ColumnExpander({ type: 'alwaysTrue', erCode: "SCORE" })
        ]
    )
}

export function TableColumnsStartList() {
    return (
        [
            ColumnBib({ disableSort: true, accessor: 'startSortOrder' }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            {
                //Header: <Label data={"HeaderTeam"} />,
                accessor: 'sortOrder',
                className: "text-start",
                headerClassName: "w-5 text-start",
                //disableSortBy: disableSort, //habilita poder ordenar
                id: 'HasSecondValue',
                Cell: (props) => {
                    const row = props.cell.row.original
                    let second = findArray(row.eventUnitEntries, { eue_code: ['SECOND_VAULT'], eue_type: ['EUE'] })?.eue_value === 'Y' ? '(2VT)' : ''
                    return (<span>{second}</span>)
                }
            },
            ColumnResult({ label: "Score" }),
            ColumnExpander({ type: 'alwaysTrue', erCode: "SCORE" })
        ]
    )
}
